import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });

const blackList = ["/ustnFinance/auction/placeBid/record","/ustnFinance/auction/placeBid","/ustnFinance/auction/placeBid/detail","/Governance/vote/Detail","/Governance/vote/create"];


router.beforeEach((to, from, next) => {
  NProgress.start();
  if(to.path == '/Producers'){
    window.open(store.state.app.TREASURE_NET_LOGIN_URL);
    NProgress.done();
    return;
  }
  else if(to.path == '/learn/QuickStart'){
    window.open(store.state.app.QuickStart_URL);
    NProgress.done();
    return;
  }
  else if(to.path == '/Documents/wiki'){
    window.open(store.state.app.aboutTreasureUrl);
    NProgress.done();
    return;
  }
  else if(to.path == '/Documents/Whitepaper'){
    window.open(store.state.app.aboutTreasureUrl);
    NProgress.done();
    return;
  }
  else if(to.path == '/Explore/GitHub'){
    window.open(store.state.app.GIT_URL);
    NProgress.done();
    return;
  }
  else{
    next();
    // NProgress.done();
    // if(store.getters.metaMaskObj.account){
    //   next();
    // }else{
    //   try{
    //     let accounts = [];
    //     if(blackList.indexOf(to.path) > -1 || to.query.detail){
    //       ethereum.request({ method: "eth_accounts" }).then(res => {
    //         accounts = res;
    //         if (!accounts[0]) {
    //           Message.warning("You must sign in to the wallet to view this page!");
    //           next(from.fullPath);
    //           NProgress.done();
    //           return;
    //         }else{
    //           next();
    //           NProgress.done();
    //         }
    //       })
    //     }else{
    //       next();
    //       NProgress.done();
    //     }
    //   }catch(e){
    //     Message.warning("You must sign in to the wallet to view this page!");
    //     next(false);
    //     NProgress.done();
    //     console.log("router",e)
    //   }
    // }
  }
})

router.afterEach(() => {
  NProgress.done();
});
